import React, { useContext } from "react";
import { a } from "kremling";
import { CpRadioContext } from "./cp-radio.component";

type RadioItemProps = {
  children: React.ReactNode;
  id: any;
  style?: React.CSSProperties;
  className?: string;
};

export function RadioItem({ children, id, style, className }: RadioItemProps) {
  const { value, disabled, onBlur, onChange, name } =
    useContext(CpRadioContext);
  const active = id === value;
  return (
    <label
      style={style}
      className={a("cp-radio")
        .a(className)
        .m("cp-radio--active", active)
        .m("cp-radio--disabled", disabled)}
    >
      <input
        name={name}
        type="radio"
        value={value || ""}
        onBlur={onBlur}
        onChange={() => onChange(id)}
        checked={active}
        disabled={disabled}
      />
      <div className={a("cp-radio__indicator")} />
      <div className="cp-radio__label">{children}</div>
    </label>
  );
}
